module.exports = __webpack_public_path__ + "img/Arkansas Outline.723b3092.png";